import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolsService } from '../../sb-editor-tools/services/tools.service';
import { SblibService } from '../../services/sblib.service';
import { PopupsComponent } from '../../sb-editor-tools/popups/popups.component';
import { ComparatorComponent } from '../../sb-editor-tools/comparator/comparator.component';
import { ToastrService } from 'ngx-toastr';
import { ColorInterfacePopups, Comparator, Popups } from '@3ddv/ngx-sites-builder-lib';

@Component({
  selector: 'app-sbeditor-tool-popupscomparator',
  templateUrl: './popupscomparator.component.html',
  styleUrls: ['./popupscomparator.component.scss'],
})
export class PopupscomparatorComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription> = [];
  public tabs = {
    active: 'popups',
  };
  popupTool;
  comparatorTool;
  @ViewChild('popups', { static: false }) popupsComponent: PopupsComponent;
  @ViewChild('comparator', { static: false }) comparatorComponent: ComparatorComponent;

  constructor(
    private toolsService: ToolsService,
    private toastrService: ToastrService,
    private sblibService: SblibService
  ) {}

  ngOnInit(): void {
    this.subscriptions = [];
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.popups) {
        this.popupTool = true;
      } else {
        this.popupTool = false;
      }

      if (res.comparator) {
        this.comparatorTool = true;
      } else {
        this.comparatorTool = false;
      }
    });
    this.subscriptions.push(tools$);
  }
  public apply() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (this.tabs.active === 'popups') {
        const popupscolors: { tool: Popups; colors: ColorInterfacePopups } = JSON.parse(
          JSON.stringify(this.popupsComponent.getTool())
        );
        res.popups = popupscolors.tool;
        res.color.manual.popups = popupscolors.colors;
      }

      if (this.tabs.active === 'comparator') {
        const comparatorcolors: { tool: Comparator } = JSON.parse(JSON.stringify(this.comparatorComponent.getTool()));
        res.comparator = comparatorcolors.tool;
      }

      this.sblibService.apply(res);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(tools$);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }
}
